export const menuConstants = {
  MENU_REQUEST: 'MENU_REQUEST',
  MENU_SUCCESS: 'MENU_SUCCESS',
  MENU_FAILURE: 'MENU_FAILURE',

  GETALL_REQUEST: 'MENU_GETALL_REQUEST',
  GETALL_SUCCESS: 'MENU_SUCCESS',
  GETALL_FAILURE: 'MENU_FAILURE',
};
